module.exports = __webpack_public_path__ + "src/img/fresh.71445484.svg";